import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["as", "isHtml", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

function respectHtml(html) {
  return html;
}

var createStyledText = function createStyledText(as, props) {
  return styled(as, props).withConfig({
    displayName: "Text",
    componentId: "sc-97zp0s-0"
  })(["font-size:", ";color:", ";*{line-height:", ";}"], props.isSmall ? '12px' : '16px', props.textColor ? props.textColor : 'inherit', props.lineHeight ? props.lineHeight : null);
};

var Text = function Text(_ref) {
  var as = _ref.as,
      isHtml = _ref.isHtml,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var Element = createStyledText(as || 'div', props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isHtml ? /*#__PURE__*/React.createElement(Element, {
    className: className,
    dangerouslySetInnerHTML: {
      __html: respectHtml(children)
    }
  }) : /*#__PURE__*/React.createElement(Element, {
    className: className
  }, children));
};

Text.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  as: PropTypes.string,
  isHtml: PropTypes.bool
};
export default Text;